import { Currency, CurrencyAmount } from '@uniswap/sdk-core'
import { useTokenApi } from 'api/Token';
import { HistoryDuration } from 'graphql/data/__generated__/types-and-hooks'
import { isGqlSupportedChain } from 'graphql/data/util'

import useStablecoinPrice from './useStablecoinPrice'

export function useUSDPrice(currencyAmount?: CurrencyAmount<Currency>): {
  data: number | undefined

  isLoading: boolean
} {
  // const chain = currencyAmount?.currency.chainId ? chainIdToBackendName(currencyAmount?.currency.chainId) : undefined
  const currency = currencyAmount?.currency

  // const { data, networkStatus } = useTokenSpotPriceQuery({
  //   // @ts-ignore
  //   variables: { chain: chain ?? Chain.CRAT, address: getNativeTokenDBAddress(chain ?? Chain.CRAT) },
  //   skip: !chain || !isGqlSupportedChain(currency?.chainId),
  //   pollInterval: PollingInterval.Normal,
  //   notifyOnNetworkStatusChange: true,
  //   fetchPolicy: 'cache-first',
  // })
  const { data, loadingToken } = useTokenApi(currency?.wrapped.address, HistoryDuration.Day)

  // Use USDC price for chains not supported by backend yet
  const stablecoinPrice = useStablecoinPrice(!isGqlSupportedChain(currency?.chainId) ? currency : undefined)
  if (!isGqlSupportedChain(currency?.chainId) && currencyAmount && stablecoinPrice) {
    return { data: parseFloat(stablecoinPrice.quote(currencyAmount).toSignificant()), isLoading: false }
  }

  const isFirstLoad = loadingToken

  // Otherwise, get the price of the token in ETH, and then multiple by the price of ETH
  const ethUSDPrice = data && currencyAmount ? parseFloat(currencyAmount.toSignificant()) * +data.priceUsd : undefined
  if (!ethUSDPrice) return { data: undefined, isLoading: isFirstLoad }

  return { data: ethUSDPrice, isLoading: false }
}
